import {connect} from 'react-redux'

import type {State} from '../../../reducers/types'
import {getAgent, getIsSakuraUI} from '../../../selectors'
import type {NormalizedAgent} from '../../../types'
import {resolveWebEntityLink, WebEntityType} from '../../../utils/entityLinks'

import AgentLink from './AgentLink'
import type {AgentLinkOwnProps, AgentLinkStateProps, AgentProps} from './AgentLink.types'

export const mapAgentToProps = (agent: NormalizedAgent | null | undefined): AgentProps => {
  if (agent == null) {
    // https://github.com/facebook/flow/issues/2977#issuecomment-385169799
    return Object.freeze({})
  }

  const {name, osType, typeId, id: agentId, links} = agent
  const hasPermissions = (links?.link?.length ?? 0) > 0

  let href = resolveWebEntityLink(WebEntityType.AGENT, agentId)

  if (href == null && hasPermissions) {
    href = resolveWebEntityLink(WebEntityType.AGENT_TYPE, typeId)
  }

  return {
    name,
    typeId,
    agentId,
    href,
    osType,
  }
}

const mapStateToProps = (state: State, props: AgentLinkOwnProps): AgentLinkStateProps => {
  const isSakuraUI = getIsSakuraUI(state)
  const agent = getAgent(state, props.agentId)
  return {...mapAgentToProps(agent), isSakuraUI}
}

export default connect(mapStateToProps)(AgentLink)
